// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { EstateOnboardingSuggestionsV2_AiSuggestionFragment } from './estateOnboardingSuggestionsV2.fragments.generated';
import { gql } from '@apollo/client';
import { EstateOnboardingSuggestionsV2_AiSuggestionFragmentDoc } from './estateOnboardingSuggestionsV2.fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EstateOnboardingUnacknowledgedSuggestionsV2QueryVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
}>;


export type EstateOnboardingUnacknowledgedSuggestionsV2Query = { __typename?: 'Query', aiSuggestions: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion', id: string }
        & EstateOnboardingSuggestionsV2_AiSuggestionFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    EstateOnboardingUnacknowledgedSuggestionsV2: 'EstateOnboardingUnacknowledgedSuggestionsV2' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const EstateOnboardingUnacknowledgedSuggestionsV2Document = gql`
    query EstateOnboardingUnacknowledgedSuggestionsV2($householdID: ID!) {
  aiSuggestions(
    where: {hasHouseholdWith: [{id: $householdID}], kindIn: [ONBOARDING_ENTITY, ONBOARDING_TESTAMENTARY_ENTITY], acceptanceStatusIsNil: true, version: 2}
    orderBy: {field: created_at, direction: DESC}
  ) {
    edges {
      node {
        id
        ...EstateOnboardingSuggestionsV2_AISuggestion
      }
    }
  }
}
    ${EstateOnboardingSuggestionsV2_AiSuggestionFragmentDoc}`;

/**
 * __useEstateOnboardingUnacknowledgedSuggestionsV2Query__
 *
 * To run a query within a React component, call `useEstateOnboardingUnacknowledgedSuggestionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useEstateOnboardingUnacknowledgedSuggestionsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstateOnboardingUnacknowledgedSuggestionsV2Query({
 *   variables: {
 *      householdID: // value for 'householdID'
 *   },
 * });
 */
export function useEstateOnboardingUnacknowledgedSuggestionsV2Query(baseOptions: Apollo.QueryHookOptions<EstateOnboardingUnacknowledgedSuggestionsV2Query, EstateOnboardingUnacknowledgedSuggestionsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstateOnboardingUnacknowledgedSuggestionsV2Query, EstateOnboardingUnacknowledgedSuggestionsV2QueryVariables>(EstateOnboardingUnacknowledgedSuggestionsV2Document, withFetchPolicyContext(options));
      }
export function useEstateOnboardingUnacknowledgedSuggestionsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstateOnboardingUnacknowledgedSuggestionsV2Query, EstateOnboardingUnacknowledgedSuggestionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstateOnboardingUnacknowledgedSuggestionsV2Query, EstateOnboardingUnacknowledgedSuggestionsV2QueryVariables>(EstateOnboardingUnacknowledgedSuggestionsV2Document, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useEstateOnboardingUnacknowledgedSuggestionsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EstateOnboardingUnacknowledgedSuggestionsV2Query, EstateOnboardingUnacknowledgedSuggestionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EstateOnboardingUnacknowledgedSuggestionsV2Query, EstateOnboardingUnacknowledgedSuggestionsV2QueryVariables>(EstateOnboardingUnacknowledgedSuggestionsV2Document, withFetchPolicyContext(options));
        }
export type EstateOnboardingUnacknowledgedSuggestionsV2QueryHookResult = ReturnType<typeof useEstateOnboardingUnacknowledgedSuggestionsV2Query>;
export type EstateOnboardingUnacknowledgedSuggestionsV2LazyQueryHookResult = ReturnType<typeof useEstateOnboardingUnacknowledgedSuggestionsV2LazyQuery>;
export type EstateOnboardingUnacknowledgedSuggestionsV2SuspenseQueryHookResult = ReturnType<typeof useEstateOnboardingUnacknowledgedSuggestionsV2SuspenseQuery>;
export type EstateOnboardingUnacknowledgedSuggestionsV2QueryResult = Apollo.QueryResult<EstateOnboardingUnacknowledgedSuggestionsV2Query, EstateOnboardingUnacknowledgedSuggestionsV2QueryVariables>;